'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentRespondersList = exports.getMeetingsLinkUrl = exports.getMeetingsLinkText = exports.getAgentType = exports.getUserId = exports.getIsOnline = exports.getIsBot = exports.getFriendlyOrFormalName = exports.getFullName = exports.getEmail = exports.getLastName = exports.getFirstName = exports.getAvatar = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _formatName = require('I18n/utils/formatName');

var _formatName2 = _interopRequireDefault(_formatName);

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _keyPaths = require('../constants/keyPaths');

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formalNameLanguages = ['de', 'ja'];

var getAvatar = exports.getAvatar = (0, _getIn2.default)(_keyPaths.AVATAR);

var getFirstName = exports.getFirstName = (0, _getIn2.default)(_keyPaths.FIRST_NAME);

var getLastName = exports.getLastName = (0, _getIn2.default)(_keyPaths.LAST_NAME);

var getEmail = exports.getEmail = (0, _getIn2.default)(_keyPaths.EMAIL);

var getFullName = exports.getFullName = function getFullName(responder) {
  return (0, _formatName2.default)({
    firstName: getFirstName(responder),
    lastName: getLastName(responder)
  });
};

var getFriendlyOrFormalName = exports.getFriendlyOrFormalName = function getFriendlyOrFormalName(responder) {
  return formalNameLanguages.indexOf((0, _getLang2.default)()) >= 0 ? getFullName(responder) : getFirstName(responder);
};

var getIsBot = exports.getIsBot = (0, _getIn2.default)(_keyPaths.IS_BOT);

var getIsOnline = exports.getIsOnline = (0, _getIn2.default)(_keyPaths.IS_ONLINE);

var getUserId = exports.getUserId = (0, _pipe2.default)((0, _getIn2.default)(_keyPaths.USER_ID), function (userId) {
  return userId && '' + userId;
});

var getAgentType = exports.getAgentType = (0, _getIn2.default)([_keyPaths.AGENT_TYPE]);

var getMeetingsLinkText = exports.getMeetingsLinkText = (0, _getIn2.default)([_keyPaths.MEETINGS_LINKS_TEXT]);

var getMeetingsLinkUrl = exports.getMeetingsLinkUrl = (0, _getIn2.default)([_keyPaths.MEETINGS_LINKS_URL]);

var getAgentRespondersList = exports.getAgentRespondersList = (0, _getIn2.default)([_senderTypes.AGENT]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/responders/operators/responderGetters.js
// module id = 31
// module chunks = 2 3